"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeConsultantForm = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _axios = require("@ori/axios");
var _logger = require("@ori/logger");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _useTranslations = require("../../../../hooks/useTranslations");
var _utils = require("../../../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ChangeConsultantForm = ({
  vipAccessLabels: {
    ConsultantChangeConsultantNumber
  }
}) => {
  const logger = (0, _logger.useLogger)('ChangeConsultantForm');
  const abortControllerRef = (0, _react.useRef)(new AbortController());
  const formRef = (0, _react.useRef)(null);
  const [areHintsLoading, setAreHintsLoading] = (0, _react.useState)(false);
  const [consultantNumber, setConsultantNumber] = (0, _react.useState)('');
  const [errorMessage, setErrorMessage] = (0, _react.useState)(null);
  const [hints, setHints] = (0, _react.useState)([]);
  const [isSubmitLocked, setIsSubmitLocked] = (0, _react.useState)(true);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    register,
    handleSubmit
  } = (0, _reactHookForm.useForm)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const handleChange = (0, _react.useCallback)(event => {
    const {
      value
    } = event.target;
    setConsultantNumber(value);
    setErrorMessage(null);
    setAreHintsLoading(true);
    setIsSubmitLocked(true);
    if (value) {
      _axios.axios.get(_utils.vipOrderUrls.consultantNumbers(value), {
        signal: abortControllerRef.current.signal
      }).then(({
        data
      }) => setHints(data.map((hint, index) => ({
        index,
        hint
      })))).catch(error => {
        if (error instanceof Error && error.name !== 'AbortError') {
          logger.error(new Error('Cannot get consultant numbers', {
            cause: error
          }));
        }
      }).finally(() => {
        setAreHintsLoading(false);
      });
    }
  }, [logger]);
  const handleSelect = (0, _react.useCallback)(event => {
    const {
      textContent: id
    } = event.target;
    setConsultantNumber(id ?? '');
    setHints([]);
    if (id) {
      _axios.axios.post(_utils.vipOrderUrls.accessSwitchValidate(id)).then(({
        data: {
          message,
          result
        }
      }) => {
        setErrorMessage(message);
        setIsSubmitLocked(!result);
      }).catch(error => logger.error(new Error('Cannot validate access switch', {
        cause: error
      })));
    }
  }, [logger]);
  const onSubmit = (0, _react.useCallback)(async () => {
    try {
      const {
        data
      } = await _axios.axios.get(_utils.vipOrderUrls.accessConsultant(consultantNumber));
      const {
        ConsultantNumber: consultant,
        ErrorMessage,
        IsAccessGranted
      } = data;
      if (IsAccessGranted) {
        try {
          await _axios.axios.post(_utils.vipOrderUrls.accessSwitch(consultant));
          formRef.current?.submit();
        } catch (error) {
          setErrorMessage(translations.failedToSubmit);
          logger.error(new Error('Cannot post VipAccessSwitch', {
            cause: error
          }));
        }
      } else {
        setErrorMessage(ErrorMessage);
      }
    } catch (error) {
      logger.error(new Error('Cannot get consultant info', {
        cause: error
      }));
    }
  }, [consultantNumber, translations.failedToSubmit, logger]);
  const renderInput = (0, _react.useCallback)(props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TextField, {
    "data-testid": getTestId(_constants.ORDER_ON_BEHALF_DIALOG_CHANGE_CONSULTANT_INPUT),
    variant: "standard",
    error: Boolean(errorMessage),
    helperText: errorMessage,
    label: ConsultantChangeConsultantNumber,
    ...register(props.id),
    onChange: handleChange,
    ...props,
    fullWidth: true
  }), [ConsultantChangeConsultantNumber, errorMessage, getTestId, handleChange, register]);
  const getOptionLabel = (0, _react.useCallback)(hint => String(hint.hint), []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.VipOrderFormRoot, {
    ref: formRef,
    "data-testid": getTestId(_constants.ORDER_FORM_ROOT),
    action: _utils.vipOrderUrls.basket,
    autoComplete: "off",
    method: "POST",
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Autocomplete, {
      fullWidth: true,
      getOptionLabel: getOptionLabel,
      id: "ConsultantNumber",
      loading: areHintsLoading,
      loadingText: translations.loading,
      noOptionsText: translations.noOptions,
      options: hints,
      renderInput: renderInput,
      onChange: handleSelect
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      disabled: isSubmitLocked,
      color: "primary",
      type: "submit",
      variant: "contained",
      children: translations.change
    })]
  });
};
exports.ChangeConsultantForm = ChangeConsultantForm;
